import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  TextField,
  Button,
  Typography,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
import { getToken } from "../utils/auth";
import "./demoCreator.css";

export default function BannerAudioPage() {
  const navigate = useNavigate();
  const params = useParams();
  const [selectedOption, setSelectedOption] = useState("products");
  const [dropdownValue, setDropdownValue] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [products, setProducts] = useState([]);

  const [bannerConfigDialog, setBannerConfigDialog] = useState(false);
  const [audioConfigDialog, setAudioConfigDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  {/* Banner Configuration Dialog */}
    const [color, setColor] = useState(null);
    const [logo, setLogo] = useState(null);
    const [logoURL, setLogoURL] = useState(null);
    const [startDate, setStartDate] = useState(null);

  {/* Set temp before saving */}
    const [tempcolor, setTempColor] = useState(null);
    const [templogo, setTempLogo] = useState(null);
    const [tempLogoURL, setTempLogoURL] = useState(null);
    const [tempStartDate, setTempStartDate] = useState(null);

  const handleLogoUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            setTempLogo(e.target.files[0]);
        }
    };

  const handleLogoUrlChange = (e) => {
        setTempLogoURL(e.target.value);
    };
  const handleBannerConfigSave = () => {
      setColor(tempcolor);
      setLogo(templogo);
      setLogoURL(tempLogoURL);
      setStartDate(tempStartDate);
      setBannerConfigDialog(false);
    };

  {/* Audio Configuration Dialog */}
  const [voices, setVoices] = useState([]);
  const [voiceName, setVoiceName] = useState(null);
  const [audioFreeText, setAudioFreeText] = useState(null);
  const [audioVoiceInstruction, setAudioVoiceInstruction] = useState(null);
  const [voiceDropdownValue, setVoiceDropdownValue] = useState(null);
  const [LanguageDropdown, setLanguageDropdown] = useState(null);
  const [audioLanguage, setAudioLanguage] = useState([]);
  const [currency, setCurrency] = useState(null);
  const [chainName, setChainName] = useState(null);
  {/* Set ELEVEN_TTS voice options */}
  const [elevenTTSVoices, setElevenTTSVoices] = useState([]);
  const [elevenTTSToggle, setElevenTTSToggle] = useState(false);

  {/* Set temp before saving */}
  const [tempAudioFreeText, setTempAudioFreeText] = useState(null);
  const [tempAudioVoiceInstruction, setTempAudioVoiceInstruction] = useState(null);
  const [tempAudioLanguage, setTempAudioLanguage] = useState(null);
  const [tempCurrency, setTempCurrency] = useState(null);
  const [tempChainName, setTempChainName] = useState(null);

  const handleChainNameChange= (e) => {
        setTempChainName(e.target.value);
    };

  const handleCurrencyChange = (e) => {
        setTempCurrency(e.target.value);
    };

  const handleFreeTextChange = (e) => {
        setTempAudioFreeText(e.target.value);
    };

  const handleVoiceInstructionChange = (e) => {
        setTempAudioVoiceInstruction(e.target.value);
    };

  const handleAudioConfigSave = () => {
      setAudioFreeText(tempAudioFreeText);
      setAudioVoiceInstruction(tempAudioVoiceInstruction);
      setStartDate(tempStartDate);
      setVoiceName(voiceDropdownValue);
      setAudioLanguage(tempAudioLanguage);
      setCurrency(tempCurrency)
      setChainName(tempChainName)
      setAudioConfigDialog(false);
    };

  {/*Text after Api Call*/}
  const [generatedText, setGeneratedText] = useState(null);
  const [audioTextDialog, setAudioTextDialog] = useState(false)

  const handleAudioTextChange= (e) => {
        setGeneratedText(e.target.value);
    };


  const [error, setError] = useState(null);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        icon: false, // remove the icon
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        icon: false, // remove the icon
      });
    }
  };

  const options = selectedOption === "campaigns" ? campaigns : products;

  // Example: Fetch products from an API (replace with actual API call)
    useEffect(() => {
    const token = getToken();
    const headers = { "Content-Type": "application/json", "x-access-token": token };
    notify("Fetching Campaigns...", "success");
    fetch(`${configData.FIELD_URL}/Campaigns/${params.retailer_id}/${params.branch_id}`, { headers })
        .then(res => {
        if (!res.ok) throw new Error(res.status);
        return res.json();
        })
        .then((data) => {
            setCampaigns(data);
            notify("Finished Fetching Campaigns...", "success");
        })
        .catch(err => notify(`${err.message} While Fetching Campaigns`, "error"));
    }, []);

    useEffect(() => {
    const token = getToken();
    const headers = { "Content-Type": "application/json", "x-access-token": token };
    notify("Fetching Products...", "success");
    fetch(`${configData.FIELD_URL}/Products/${params.retailer_id}/${params.branch_id}`, { headers })
        .then(res => {
        if (!res.ok) throw new Error(res.status);
        return res.json();
        })
        .then(data => {
          setProducts(data)
          notify("Finished Fetching Products...", "success");
        })
        .catch(err => notify(`${err.message} While Fetching Products`, "error"));
    }, []);

    const createBanner = () => {
        setLoading(true);
        if (!dropdownValue || !dropdownValue.value) {
            notify("Please select a campaign or product first", "error");
            setLoading(false);
            return;
        }

        const isoDate = startDate ? startDate.toISOString() : null;
        const body = {
          Id: dropdownValue?.value,
          color: color|| null,
          startDate: isoDate,
          logo: logo || null,
          logoURL: logoURL || null,
          price: dropdownValue?.price || null,
          Image_Url: dropdownValue?.image || null,
          banner_type: selectedOption === "campaigns",
          product_title: dropdownValue?.label
        };

        fetch(`${configData.DEMO_URL}/CreateBanner/${params.retailer_id}/${params.branch_id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        })
            .then(res => {
                if (!res.ok) throw new Error(res.status);
                return res.json();
            })
            .then(data => {
                if (data.banner_url) {
                    window.open(data.banner_url, '_blank'); // open in new tab
                } else {
                    notify("No banner URL returned from server", "error")
                }
            })
            .catch(err => notify(err.message, "error"))
            .finally(() => setLoading(false));
    };

    // Example: Fetch Audio Voices from an API (replace with actual API call)
    useEffect(() => {
      fetch(`${configData.DEMO_URL}/Voices`)
        .then(res => {
          if (!res.ok) throw new Error(`HTTP error! ${res.status} ${res.statusText}`);
          return res.json();
        })
        .then(data => {
          setLanguageDropdown(data.languages);
          setVoices(data.voices);
          setElevenTTSVoices(data.eleven_tts_voices);
        })
        .catch(err => notify(err.message, "error"))
    }, []);

    const createAudioText = () => {
        setLoading(true);
        if (!dropdownValue || !dropdownValue.value) {
            notify("Please select a campaign or product first", "error");
            setLoading(false);
            return;
        }
        const title = options !== "campaigns" 
          ? `${dropdownValue?.label} ${dropdownValue?.price ?? ''}` 
          : dropdownValue?.label;

        const body = {
          Id: dropdownValue?.value,
          endDate_Unix: dropdownValue?.end_date_unix|| null,
          title: title,
          freeText: audioFreeText || null,
          locale: audioLanguage?.value || null,
          currency: currency || null,
          chainName: chainName || null
        };
        fetch(`${configData.DEMO_URL}/CreateAudioText/${params.retailer_id}/${params.branch_id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        })
            .then(res => {
                if (!res.ok) notify(`Error Fetching Data ${res.status} `, "error");;
                return res.json();
            })
            .then(data => {
                if (data.audio_text) {
                    setGeneratedText(data.audio_text);
                    setAudioTextDialog(true);
                }
            })
            .catch(err => notify(err.message, "error"))
            .finally(() => setLoading(false));
    };

    const createAudio = () => {
        setLoading(true);
        if (!dropdownValue || !dropdownValue.value) {
            notify("Please select a campaign or product first", "error");
            setLoading(false);
            return;
        }

        const isoDate = startDate ? startDate.toISOString() : null;
        const body = {
          Id: dropdownValue?.value,
          startDate: isoDate || null,
          freeText: generatedText || null,
          voiceInstructions: audioVoiceInstruction || null,
          voiceName: voiceName?.value || null,
          elevenTTS: elevenTTSToggle || null,
        };
        fetch(`${configData.DEMO_URL}/CreateAudio/${params.retailer_id}/${params.branch_id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        })
            .then(res => {
                if (!res.ok){
                  notify(`Error Fetching Data ${res.status} `, "error");
                  return null
                }
                return res.json();
            })
            .then(data => {
                if (data && data.audio_file) {
                    window.open(data.audio_file, '_blank');
                } else if (data && data.error) {
                    notify(data.error, "error");
                } else {
                    notify("No data was received", "error");
                }
            })
            .catch(err => notify(err.message, "error"))
            .finally(() => setLoading(false));
    };

    


  return (
  <div className="login-container">
      <div className="login-form">

        {error && (
          <div className="login-error-message" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={(e) => e.preventDefault()}>
          {/* Login Inputs go here */}
        </form>
         <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* Banner & Audio Control */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              width: "100%",
              maxWidth: 600,
              borderRadius: 3,
              backgroundColor: "#fafafa",
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              mb={3}
              textAlign="center"
            >
              Banner & Audio Control
            </Typography>

            {/* Radio and Filterable Dropdown */}
            <Stack direction="row" spacing={3} alignItems="flex-end" mb={4}>
              <FormControl>
                <FormLabel sx={{ fontWeight: 600 }}>Select Type</FormLabel>
                <RadioGroup
                  row
                  value={selectedOption}
                  onChange={(e) => {
                    setSelectedOption(e.target.value)
                    setDropdownValue(null)
                  }}
                >
                  <FormControlLabel
                    value="products"
                    control={<Radio />}
                    label="Products"
                  />
                  <FormControlLabel
                    value="campaigns"
                    control={<Radio />}
                    label="Campaigns"
                  />
                </RadioGroup>
              </FormControl>

              <Autocomplete
                size="small"
                value={dropdownValue}
                onChange={(event, newValue) => setDropdownValue(newValue)}
                options={options}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => option.value === value?.value} // important!
                renderOption={(props, option) => (
                    <li {...props} key={option.value}> {/* use unique value here */}
                    {option.label}
                    </li>
                )}
                sx={{ minWidth: 220 }}
                renderInput={(params) => (
                    <TextField {...params} label="Select" variant="outlined" />
                )}
                />
            </Stack>

            {/* Config Buttons */}
            <Stack direction="row" spacing={3} justifyContent="center" mb={2}>
              <Button
                variant="contained"
                color="primary"
                sx={{ px: 4, textTransform: "none", borderRadius: 2 }}
                onClick={() => setBannerConfigDialog(true)}
                >
                Config Banner
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ px: 4, textTransform: "none", borderRadius: 2 }}
                onClick={() => setAudioConfigDialog(true)}
              >
                Config Audio
              </Button>
              
            </Stack>

            {/* Trigger Buttons */}
            <Stack direction="row" spacing={3} justifyContent="center">
              <Button
                variant="contained"
                color="success"
                sx={{ px: 4, textTransform: "none", borderRadius: 2 }}
                onClick={() => createBanner()}
                // disabled={loading || selectedOption !== "campaigns"}
              >
                Trigger Banner
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={{ px: 4, textTransform: "none", borderRadius: 2 }}
                onClick={() => createAudioText() }
                disabled={loading}
              >
                Trigger Audio
              </Button>
            </Stack>
            {/* Config Banner Dialog */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Dialog
                    open={bannerConfigDialog}
                    onClose={() => setBannerConfigDialog(false)}
                >
                    <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        mt: 2,
                        minWidth: 400,
                    }}
                    >
                    {/* Color Picker */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Color</FormLabel>
                        <input
                        type="color"
                        value={tempcolor|| "#000000"}
                        onChange={(e) => setTempColor(e.target.value)}
                        style={{
                            width: "100%",
                            height: 40,
                            border: "none",
                            cursor: "pointer",
                            borderRadius: 4,
                        }}
                        />
                    </FormControl>

                    {/* Logo Upload */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Logo</FormLabel>

                        {/* File Upload */}
                        <label
                            htmlFor="logo-upload"
                            style={{
                            display: "inline-block",
                            padding: "10px 20px",
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            borderRadius: 4,
                            cursor: "pointer",
                            textAlign: "center",
                            marginBottom: 8,
                            }}
                        >
                            Choose File
                        </label>
                        <input
                            id="logo-upload"
                            type="file"
                            accept="image/*"
                            onChange={handleLogoUpload}
                            style={{ display: "none" }}
                        />
                        {templogo instanceof File && (
                            <Typography sx={{ mt: 1 }}>Selected file: {templogo.name}</Typography>
                        )}

                        {/* OR URL input */}
                        <TextField
                            label="Or enter image URL"
                            variant="outlined"
                            size="small"
                            value={tempLogoURL}
                            onChange={handleLogoUrlChange}
                        />
                    </FormControl>

                    {/* Start Date Picker */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Start Date</FormLabel>
                        <DatePicker
                        value={tempStartDate}
                        onChange={(newValue) => setTempStartDate(newValue)}
                        renderInput={(params) => <TextField {...params} />}
                        />
                    </FormControl>
                    </DialogContent>

                    <DialogActions>
                    <Button onClick={() => setBannerConfigDialog(false)}>Cancel</Button>
                    <Button onClick={handleBannerConfigSave} variant="contained" color="primary">
                        Save
                    </Button>
                    </DialogActions>
                </Dialog>
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Dialog
                    open={audioConfigDialog}
                    onClose={() => setAudioConfigDialog(false)}
                >
                    <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        mt: 2,
                        minWidth: 400,
                    }}
                    >
                    {/* Voice Selection */}
                    <Stack direction="row" spacing={3} alignItems="flex-end" mb={4}>
                      <FormControl>
                        <FormLabel sx={{ fontWeight: 600 }}>ELEVEN_TTS</FormLabel>
                        <RadioGroup
                          row
                          value={elevenTTSToggle ? "True" : "False" }
                          onChange={(e) => {
                            setElevenTTSToggle(e.target.value === "True");
                            setVoiceDropdownValue(null);
                          }}
                        >
                          <FormControlLabel
                            value = "True"
                            control={<Radio />}
                            label="True"
                          />
                          <FormControlLabel
                            value="False"
                            control={<Radio />}
                            label="False"
                          />
                        </RadioGroup>
                      </FormControl>
                      <Autocomplete
                        size="small"
                        value={voiceDropdownValue}
                        onChange={(event, newValue) => setVoiceDropdownValue(newValue)}
                        options={elevenTTSToggle ? elevenTTSVoices : voices}
                        getOptionLabel={(option) => option.label || ""}
                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                        renderOption={(props, option) => (
                          <li {...props} key={option.value}>
                            {option.label}
                          </li>
                        )}
                        sx={{ minWidth: 220 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Voices" variant="outlined" />
                        )}
                      />
                    </Stack>

                    <FormControl fullWidth>
                      <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Language</FormLabel>
                      <Autocomplete
                        size="small"
                        value={tempAudioLanguage}
                        onChange={(event, newValue) => setTempAudioLanguage(newValue)}
                        options={LanguageDropdown}
                        getOptionLabel={(option) => option.label || ""}
                        isOptionEqualToValue={(option, value) => option.value === value?.value} // important!
                        renderOption={(props, option) => (
                            <li {...props} key={option.value}> {/* use unique value here */}
                            {option.label}
                            </li>
                        )}
                        sx={{ minWidth: 220 }}
                        renderInput={(params) => (
                            <TextField {...params} label="Select" variant="outlined" />
                        )}
                      />
                    </FormControl>

                    {/* Free Text */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Chain Name</FormLabel>
                        <TextField
                            label="Optional"
                            variant="outlined"
                            size="small"
                            value={tempChainName}
                            onChange={handleChainNameChange}
                        />
                    </FormControl>

                    {/* Free Text */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Currency</FormLabel>
                        <TextField
                            label="Optional"
                            variant="outlined"
                            size="small"
                            value={tempCurrency}
                            onChange={handleCurrencyChange}
                        />
                    </FormControl>

                    {/* Free Text */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Free Text</FormLabel>
                        <TextField
                            label="Optional"
                            variant="outlined"
                            size="small"
                            value={tempAudioFreeText}
                            onChange={handleFreeTextChange}
                        />
                    </FormControl>

                    {/* Free Text */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Voice Instruction</FormLabel>
                        <TextField
                            label="Optional"
                            variant="outlined"
                            size="small"
                            value={tempAudioVoiceInstruction}
                            onChange={handleVoiceInstructionChange}
                        />
                    </FormControl>

                    {/* Start Date Picker */}
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1, fontWeight: 500 }}>Start Date</FormLabel>
                        <DatePicker
                        value={tempStartDate}
                        onChange={(newValue) => setTempStartDate(newValue)}
                        renderInput={(params) => <TextField {...params} />}
                        />
                    </FormControl>
                    </DialogContent>

                    <DialogActions>
                    <Button onClick={() => setAudioConfigDialog(false)}>Cancel</Button>
                    <Button onClick={handleAudioConfigSave} variant="contained" color="primary">
                        Save
                    </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                  open={audioTextDialog}
                  onClose={() => setAudioTextDialog(false)}
                  fullWidth
                  maxWidth="sm"
                >
                  <DialogContent>
                    <Typography variant="h6" gutterBottom>
                      Generated Audio Text
                    </Typography>
                    <TextField
                      multiline
                      fullWidth
                      minRows={5}
                      value={generatedText}
                      onChange={handleAudioTextChange} // pass the event
                      variant="outlined"
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setAudioTextDialog(false)} color="secondary">
                      Close
                    </Button>
                    <Button
                      onClick={() => {
                        setAudioTextDialog(false)
                        createAudio();
                      }}
                      variant="contained"
                      color="primary"
                    >
                      Create Audio
                    </Button>
                  </DialogActions>
                </Dialog>
            </LocalizationProvider>
            {loading && (
              <Box
                position="absolute"
                bottom={0}
                left={0}
                width="100%"
                textAlign="center"
                py={1}
                bgcolor="rgba(255,255,255,0.8)"
              >
                <CircularProgress size={24} />
              </Box>
            )}
          </Paper>
        </Box>
      </div>
  </div>
);

}
